import { render, staticRenderFns } from "./Userorderdjd.vue?vue&type=template&id=5516ac0e&scoped=true&"
import script from "./Userorderdjd.vue?vue&type=script&lang=js&"
export * from "./Userorderdjd.vue?vue&type=script&lang=js&"
import style0 from "./Userorderdjd.vue?vue&type=style&index=0&id=5516ac0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5516ac0e",
  null
  
)

export default component.exports